import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import moment from 'moment';
import { withRouter } from 'react-router';
import uuid from 'uuid';

import { Card, Loader, Button, Popup, Table } from 'semantic-ui-react';
import _ from 'lodash';
import { getDiscussions } from './utils';
import hasUserInfo from '../../hocs/has-user-info';
import { ReportRow, ReportTableHeader, NoSummaryCard } from './components';

const JOINED_FORMAT = 'MMMM Do YYYY, h:mm:ss a';

class InfluencerCampaigns extends Component {
  static propTypes = {
    influencer: PropTypes.object.isRequired,
    influencerDetails: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: '',
      success: '',
      invitations: [],
      permissions: [],
      discussions: [],
    };
  }

  componentDidMount() {
    this.setState({ success: '' });
    const { influencer, userInfo } = this.props;

    if (influencer && influencer.primarySocialHandle) {
      getDiscussions(influencer.primarySocialHandle, userInfo)
        .then(discussions => {
          const loading = false;
          this.setState({
            loading,
            discussions,
          });
        });
    }
  }

  getCampaignDateString = campaignDate => (campaignDate ? moment(campaignDate).format('ll') : 'error fetching date')

  render() {
    const { discussions, loading } = this.state;
    const { influencer, router } = this.props;

    const sortedDiscussions = _.orderBy(discussions, 'campaign.liveDate', 'desc');
    return (
      <div className="page-content">
        <h1>Influencer Campaign History</h1>

        <div style={{ marginTop: 30, minHeight: 400 }}>
          {
            loading &&
              <div style={{ marginTop: 50, color: 'gray' }}>
                <Loader active inline="centered" size="massive" >
                Loading {influencer.name}&apos;s campaign history...
                </Loader>
              </div>
          }

          {
            !loading && _.isEmpty(discussions) &&
            <h3 style={{ textAlign: 'center', color: 'grey' }}>No campaigns yet...</h3>
          }

          {
            !loading &&
            _.map(sortedDiscussions, d => {
              const liveDateString = this.getCampaignDateString(_.get(d.campaign, 'liveDate', null));
              const endDateString = this.getCampaignDateString(_.get(d.campaign, 'endDate', null));

              if (!d.contentSummary) {
                return (
                  <NoSummaryCard
                    name={d.campaign.name}
                    id={d.campaign.id}
                    createdBy={d.campaign.createdBy}
                    liveDateString={liveDateString}
                    endDateString={endDateString}
                    router={router}
                  />
                );
              }

              const campaignName = d.campaign.name || d.contentSummary.campaignName;
              const productDetails = _.get(d.campaign, 'ecommerceSettings.productDetails');
              return (
                <Card fluid color="pink">
                  <Card.Content>
                    <table width="100%">
                      <tr>
                        <td>
                          <h4>{campaignName}</h4>
                          <p style={{ color: 'grey' }}><strong>campaign owner: </strong> {d.campaign.createdBy}</p>
                        </td>
                        <td style={{ color: 'gray' }}>
                          <p>live date: {liveDateString}</p>
                          <p>end date: {endDateString}</p>
                        </td>
                        <td>
                          <Popup
                            trigger={
                              <Button
                                floated="right"
                                circular
                                inverted
                                color="green"
                                icon="external alternate"
                                onClick={() => window.open(`/campaign/${d.campaign.id}/collaborations`, '_blank')}
                              />
                            }
                            content={`Open the ${d.campaign.name} campaign in a new tab.`}
                          />
                          <Popup
                            trigger={
                              <Button
                                floated="right"
                                circular
                                inverted
                                color="pink"
                                icon="arrow alternate circle right"
                                onClick={() => router.push(`/campaign/${d.campaign.id}/collaborations`)}
                              />
                            }
                            content={`Open the ${d.campaign.name} campaign.`}
                          />

                        </td>
                      </tr>
                    </table>
                  </Card.Content>
                  <Card.Content>
                    { d.contentSummary ?
                      <Table celled>
                        <ReportTableHeader productDetails={productDetails} />
                        <Table.Body>
                          <ReportRow
                            key={uuid()}
                            {...d.contentSummary}
                            discussionId={d.id}
                            productDetails={productDetails}
                          />
                        </Table.Body>
                      </Table>
                      : <div>CAMPAIGN {d.campaign.id} NOT PROCESSED YET</div>
                    }
                  </Card.Content>
                  <Card.Content extra>
                  last analysis: {moment(d.contentSummary.analysisDate).format(JOINED_FORMAT)}
                  </Card.Content>
                </Card>
              );
            })
          }
        </div>
      </div>
    );
  }
}

export default compose(
  hasUserInfo,
  withRouter,
)(InfluencerCampaigns);



/** WEBPACK FOOTER **
 ** ./src/components/influencer-campaigns/index.js
 **/